var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { get, getRawValue } from '../../utils/get';
import { getKeys, siteIDs } from '../../adapters/utils';
import { updateValueByIdentifier } from '../../tags/values/update-by-identifier';
import { IDENTIFIERS } from '../../types/Identifiers';
import { getCurrentLanguage, getCurrentSeoLang, } from '../blog-post/calculated/getCurrentLanguage';
import { getPageUrl } from './calculated/getPageUrl';
import { getMultilingualTags } from '../../renderer/get-multilingual-tags';
import { SD_STATUS } from '../../consts';
import { getRssFullURL } from '../utils';
import { RSS_ROUTES, RSS_ROUTE_TYPES } from '../consts';
import { ITEM_TYPES } from '../../types/ItemTypes';
import { resolveItemTypeMultilingualUrl } from '../../utils/resolve-item-type-multilingual-url';
var IDs = {
    NAME: 'blog-category.name',
    IMAGE: 'blog-category.image',
    IMAGE_HEIGHT: 'blog-category.image.height',
    IMAGE_WIDTH: 'blog-category.image.width',
    PAGE_URL: 'blog-category.url',
    PREV_PAGE_URL: 'blog-category.prevUrl',
    NEXT_PAGE_URL: 'blog-category.nextUrl',
    CURRENT_PAGE: 'blog-category.currentPage',
    TOTAL_PAGE_COUNT: 'blog-category.totalPageCount',
    BLOG_FEED_ROUTE: 'blog-category.blogFeedRoute',
};
var userVisible = [IDs.NAME, IDs.PAGE_URL, IDs.IMAGE];
var requiredSchemaVariables = [];
var SchemaTypes = {
    BLOG_CATEGORY_COLLECTION: 'blog-category-collection-preset',
};
export default {
    IDs: IDs,
    SchemaTypes: SchemaTypes,
    requiredSchemaVariables: requiredSchemaVariables,
    getData: function (item) {
        var _a;
        return (_a = {},
            _a[IDs.NAME] = get(item, 'category.label'),
            _a[IDs.IMAGE] = get(item, 'category.image.url'),
            _a[IDs.IMAGE_HEIGHT] = get(item, 'category.image.height'),
            _a[IDs.IMAGE_WIDTH] = get(item, 'category.image.width'),
            _a[IDs.PAGE_URL] = resolveItemTypeMultilingualUrl(ITEM_TYPES.BLOG_CATEGORY, item, getPageUrl(item)),
            _a[IDs.PREV_PAGE_URL] = get(item, 'category.prevUrl'),
            _a[IDs.NEXT_PAGE_URL] = get(item, 'category.nextUrl'),
            _a[IDs.CURRENT_PAGE] = get(item, 'category.pagination.currentPage'),
            _a[IDs.TOTAL_PAGE_COUNT] = get(item, 'category.pagination.totalPages'),
            _a[IDs.BLOG_FEED_ROUTE] = get(item, 'category.blogFeedRoute') ||
                getRssFullURL({
                    siteUrl: get(item, 'context.siteUrl'),
                    rssRoute: RSS_ROUTES[RSS_ROUTE_TYPES.BLOG],
                }),
            _a[siteIDs.CURRENT_PAGE_NUMBER] = get(item, 'category.pagination.currentPage'),
            _a[siteIDs.TOTAL_PAGE_COUNT] = get(item, 'category.pagination.totalPages'),
            _a);
    },
    getSdStatus: function () { return SD_STATUS.DOES_NOT_EXIST; },
    getLegacySeoBlob: function (item) {
        var tags = updateValueByIdentifier([], IDENTIFIERS.TITLE, get(item, 'category.title'));
        tags = updateValueByIdentifier(tags, IDENTIFIERS.DESCRIPTION, get(item, 'category.description'));
        return { tags: tags };
    },
    getDynamicPatternsSchema: function (item) {
        var translatedPages = getRawValue(item, 'category.translatedPages') || [];
        var hasTranslations = Boolean(translatedPages.length);
        var currentLanguageCode = getCurrentLanguage(item);
        var currentSeoLang = getCurrentSeoLang(item);
        var currentUrl = getPageUrl(item);
        if (!item || !hasTranslations) {
            return { tags: [] };
        }
        var siteUrl = get(item, 'context.siteUrl');
        var tags = getMultilingualTags(__spreadArrays([
            {
                url: currentUrl,
                langCode: currentLanguageCode,
                seoLang: currentSeoLang,
            }
        ], translatedPages, [
            { url: siteUrl, langCode: 'x-default' },
        ]));
        return { tags: tags };
    },
    getSlug: function (item) { return get(item, 'category.slug'); },
    setFullUrl: function (item, url) {
        if (url === void 0) { url = ''; }
        item = JSON.parse(JSON.stringify(item));
        item.category.path = url;
        item.category.canonicalUrl = url;
        return item;
    },
    getFullUrl: function (item) { return get(item, 'category.canonicalUrl'); },
    updateItemDataWithSlug: function (item) { return item; },
    getBiData: function () { },
    getKeys: function () { return getKeys(IDs, userVisible); },
    getSdKeys: function () { return []; },
    hasMultilingual: function (item) {
        return Array.isArray(getRawValue(item, 'category.translatedPages'));
    },
};
